// extracted by mini-css-extract-plugin
export default {"label":"Label_label__oVE6d","optional":"Label_optional__8k7id","description":"Label_description__bipvN"};